<div class="auth-full-height d-flex flex-row align-items-center">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-md-4">
                <div class="card">
                    <div class="card-body">
                        <div class="m-2">
                            <div class="d-flex justify-content-center mt-3">
                                <img style="max-width:300px;width: 100%;" src="/assets/images/Logo-01.png" alt="">
                                <!-- <logo class="text-center" logoType="fold"></logo> -->
                            </div>
                            <div class="text-center mt-3">
                                <h3 class="fw-bolder">Forgot Password</h3>
                                <p class="text-muted">No worries, we'll send you reset instructions</p>
                            </div>
                            <div *ngIf="showError" class="alert alert-danger" role="alert">
                                {{errorMessage}}
                            </div>
                            <div *ngIf="showSuccess" class="alert alert-success" role="alert">
                                {{successMessage}}
                            </div>
                            <form [formGroup]="forgotPasswordForm" autocomplete="off" novalidate
                                (ngSubmit)="forgotPassword(forgotPasswordForm.value)">
                                <div class="form-group mb-3">
                                    <label for="email" class="col-form-label col-sm-2">Email:</label>
                                    <div class="col-md-12">
                                        <input type="text" id="email" formControlName="email"
                                            class="form-control no-validation-icon no-success-validation" />
                                    </div>
                                    <div class="col-md-5">
                                        <em *ngIf="validateControl('email') && hasError('email', 'required')">Email is
                                            required</em>
                                    </div>
                                </div>
                                <br>

                                <button type="submit" class="btn btn-primary w-100"
                                    [disabled]="!forgotPasswordForm.valid">Reset Password</button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>